let indexedDB =
  window.indexedDB ||
  window.webkitIndexedDB ||
  window.mozIndexedDB ||
  window.OIndexedDB ||
  window.msIndexedDB;
const dbVersion = 1.0;

const STORE_NAME = 'blobs';

export async function openDatabase() {
  return new Promise((resolve, reject) => {
    try {
      let request = indexedDB.open(STORE_NAME, dbVersion);
      request.onerror = function(event) {
        console.log('Error creating/accessing IndexedDB database');
        reject(event);
      };

      request.onsuccess = function(event) {
        console.log('Success creating/accessing IndexedDB database');
        let db = request.result;

        db.onerror = function(event) {
          console.log('Error creating/accessing IndexedDB database');
          reject(event);
        };

        // Interim solution for Google Chrome to create an objectStore. Will be deprecated
        if (db.setVersion) {
          if (db.version !== dbVersion) {
            let setVersion = db.setVersion(dbVersion);
            setVersion.onsuccess = function() {
              db.createObjectStore(STORE_NAME);
              resolve(db);
            };
          } else {
            resolve(db);
          }
        } else {
          resolve(db);
        }
      };

      // For future use. Currently only in latest Firefox versions
      request.onupgradeneeded = function(event) {
        request.result.createObjectStore(STORE_NAME);
      };
    } catch (e) {
      reject(e);
    }
  });
}

export async function store(db, url, blob) {
  return new Promise((resolve, reject) => {
    let transaction = db.transaction([STORE_NAME], 'readwrite');
    try {
      const request = transaction.objectStore(STORE_NAME).put(blob, url);
      request.onsuccess = resolve;
      request.onerror = reject;
    } catch (e) {
      reject(e);
    }
  });
}

export async function fetch(db, url) {
  return new Promise((resolve, reject) => {
    let transaction = db.transaction([STORE_NAME], 'readwrite');
    try {
      const request = transaction.objectStore(STORE_NAME).get(url);
      request.onsuccess = function(event) {
        let blob = event.target.result;
        if (blob) {
          resolve(URL.createObjectURL(blob));
        } else {
          resolve(null);
        }
      };
      request.onerror = reject;
    } catch (e) {
      reject(e);
    }
  });
}

export function clear(db, urls) {
  const store = db
    .transaction([STORE_NAME], 'readwrite')
    .objectStore(STORE_NAME);
  const keys = new Set(urls);
  store.getAllKeys().onsuccess = function(event) {
    if (event.target.result) {
      event.target.result.forEach(key => {
        if (!keys.has(key)) {
          store.delete(key);
        }
      });
    }
  };
}
